// @flow
import { all, call } from "redux-saga/effects";
import type { Saga } from "redux-saga";
import watchGetFormDataSaga from "../../sagas/getMotivationTemplate";
import watchSaveFormDataSaga from "../../sagas/saveMotivationTemplate";

export default function* mainSaga(): Saga<void> {
  yield all([
    call(watchGetFormDataSaga),
    call(watchSaveFormDataSaga),
  ]);
}
